

import React, { useEffect, useRef } from 'react';
import '../../../assets/css/screens/customer/termsconditions/TermsConditions.css'; // External CSS file import
import MyNavbar from '../../../components/customer/home/Navbar/MyNavbar';
import Myfooter from '../../../components/customer/home/footer/Myfooter';
import Topbar from '../../../components/customer/home/topbar/Topbar';
import {
  FileText, Shield, Scale, CreditCard,
  Ban, RefreshCw, AlertCircle
} from 'lucide-react';
import ScrollToTop from '../../general/scrolltotop/ScrollToTop';


const SECTIONS = [
  {
    icon: <FileText size={20} />,
    title: '1. Acceptance of Terms',
    text: 'By accessing and using WorkHub, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use our platform.',
  },
  {
    icon: <Shield size={20} />,
    title: '2. User Accounts',
    text: 'You must provide accurate and complete information when creating an account. You are responsible for maintaining the confidentiality of your account credentials. WorkHub reserves the right to suspend or terminate accounts that violate our terms.',
  },
  {
    icon: <Scale size={20} />,
    title: '3. Service Provider Obligations',
    text: 'Service providers must complete KYC verification and maintain accurate profile information. Providers agree to deliver services as described, maintain professional conduct, and comply with all applicable laws and regulations.',
  },
  {
    icon: <CreditCard size={20} />,
    title: '4. Payments & Fees',
    text: 'All payments are processed securely through our platform. WorkHub charges a service fee on each completed transaction. Providers receive payments after successful service completion and customer confirmation.',
  },
  {
    icon: <Ban size={20} />,
    title: '5. Prohibited Activities',
    text: 'Users must not engage in fraudulent activities, harassment, discrimination, or any illegal conduct. Sharing false information, spamming, or attempting to circumvent our payment system is strictly prohibited.',
  },
  {
    icon: <RefreshCw size={20} />,
    title: '6. Cancellation & Refunds',
    text: 'Customers may cancel bookings before the scheduled service time. Refund eligibility depends on the cancellation timing and service type. Disputes are handled through our support team with fair resolution policies.',
  },
  {
    icon: <AlertCircle size={20} />,
    title: '7. Limitation of Liability',
    text: 'WorkHub acts as a marketplace connecting customers with service providers. We are not liable for the quality of services rendered. However, we maintain strict quality standards and take action against providers who fail to meet them.',
  },
];

const TermsConditions = () => {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = [];

    itemRefs.current.forEach((el, i) => {
      if (!el) return;
      const obs = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('tc-item--visible');
            obs.disconnect();
          }
        },
        { threshold: 0.15 }
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => observers.forEach(o => o.disconnect());
  }, []);

  return (
    <>
    <ScrollToTop/>
    <Topbar/>
    <MyNavbar/>
    <div className="tc-page">
      <div className="tc-container">

        {/* Header */}
        <div className="tc-header">
          <h2 className="tc-main-title">Terms &amp; Conditions</h2>
          <p className="tc-updated">Last updated: March 2026</p>
          <p className="tc-intro">
            Welcome to WorkHub. These terms and conditions outline the rules and regulations
            for the use of our platform. Please read them carefully before using our services.
          </p>
        </div>

        {/* Sections */}
        <div className="tc-list">
          {SECTIONS.map((sec, i) => (
            <div
              key={i}
              className="tc-item"
              ref={el => (itemRefs.current[i] = el)}
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              {/* Icon + vertical line */}
              <div className="tc-item__left">
                <div className="tc-item__icon">{sec.icon}</div>
                {i < SECTIONS.length - 1 && <div className="tc-item__line" />}
              </div>

              {/* Content */}
              <div className="tc-item__content">
                <h5 className="tc-item__title">{sec.title}</h5>
                <p className="tc-item__text">{sec.text}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
    <Myfooter/>
    </>
  );
};

export default TermsConditions;